export default "__VITE_ASSET__DtGlBJgI__"